import { IDocument } from "@rentiohq/shared-frontend/dist/types/document.types";
import { compact } from "lodash";

export const getDocumentActivityFilter = (params: { document: IDocument }) => {
  const { document } = params;

  // TODO:
  // If backend would log activities for documents ((e.g. doc shared with X member)) itself we can remove this check,
  // for now only show the history if theres a linked document package
  if (!document?.documentPackageId) {
    return;
  }

  return {
    where: {
      or: compact([
        { documentId: document.id },
        { documentPackageId: document.documentPackageId },
      ]),
    },
  };
};
